// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"60cc3796","455":"e3268402","977":"bcc5f7ad"}[chunkId] + ".chunk.js";
};